var lx = lx || {};
/*File related functions*/
lx.file = lx.file || {};
lx.file = {
    console: function(pId, pChecked, pEty, pPath, pEdit, pPage, pSearch, pSort, pProfileId) {
        if (pPage == 248) {
            vProcess = 'FileManagementAttach';
        } else {
            vProcess = 'FileManagementConsole';
        }
        apex.server.process(vProcess, {
            x01: pId,
            x02: pChecked,
            x03: pEty,
            x04: pPath,
            x05: pEdit,
            x06: pPage,
            x07: pSearch,
            x08: pSort,
			x09: pProfileId
        }, {
            dataType: "html",
            success: function(r) {
                if (r) {
                    $("#uiMgmtConsole").html(r);
                    if (pPage == 248) {
                        iFrameFullHeight(50);
                    }
                }
            }
        });
    },
    reorder: function() {
        $('#uiFileMgmt').find("table.ui-file-mgmt-tbl").sortable({
            cursor: "move",
            handle: ".ui-file-mgmt-sort",
            items: ".ui-file-mgmt-sort-tr",
            containment: "table.ui-file-mgmt-tbl",
            opacity: 0.9,
            revert: true,
            start: function(e, u) {
                u.placeholder.height(u.item.height());
            },
            helper: function(e, u) {
                u.children().each(function() {
                    $(this).width($(this).width());
                });
                return u;
            },
            tolerance: "pointer",
            update: function(event, ui) {
                var vSortOrder = $('#uiFileMgmt table.ui-file-mgmt-tbl.ui-sortable tbody').sortable('serialize');
                var str = "";
                vSortOrder.find('[id=uiFileMgmtRec]').each(function() {
                    str += $(this).text() + ",";
                });
                apex.server.process("reorderFiles", {
                    x01: str
                }, {
                    dataType: "text"
                });
            }
        }).find(".ui-file-mgmt-sort").css({
            "cursor": "move"
        }).disableSelection();
    },
    drop: function() {
        $("tr#ui-fldr-sort").each(function() {
            $(this).droppable({
                drop: function(event, ui) {
                    var vFldrId = $(this).find('[id=uiFileMgmtFldrRec]').text();
                    var vRecId = $('.ui-sortable-helper').find('[id=uiFileMgmtRec]').text();
                    apex.server.process("dropFiles", {
                        x01: vFldrId,
                        x02: vRecId,
                        x03: 'D'
                    }, {
                        dataType: "text",
                        success: function(r) {
                            location.reload();
                        }
                    });
                }
            });
        });
    },
    notes: function(pId, pType) {
        apex.server.process("saveFileNotes", {
            x01: pId,
            x02: $v("uiFileNotes" + pId),
            x03: pType
        }, {
            dataType: "html",
            success: function(r) {
                if (r == 'NOK') {
                    $("#uiFileNotes" + pId).addClass("animateHighlight1");
                } else {
                    $("#uiFileNotes" + pId).addClass("animateHighlight2");
                }
            }
        });
    },
    attach: function(pAid, pEid, pSid, pAdd, pThis, pPublic) {
        apex.server.process("setFileAttachment", {
            x01: pAid,
            x02: pEid,
            x03: pSid,
            x04: pAdd,
            x05: (pPublic ? 'Y' : 'N')
        }, {
            dataType: "html",
            success: function(r) {
                if ($v("pFlowStepId") == 251) $(pThis).closest("tr").remove();
                else {
                   // $(pThis).closest("tr").toggleClass("selected");
                    if ($("#attachFile_" + pAid).html().indexOf(lx.tran.get('ATTACH')) != -1) {
                        $("#attachFile_" + pAid).html(lx.tran.get('REMOVE'));
						$("#attachFile_" + pAid).css("color","#D2423B");
                    } else {
                        $("#attachFile_" + pAid).html(lx.tran.get('ATTACH'));
						$("#attachFile_" + pAid).css("color","#02535B");
                    }
                }
				console.log('pEid, pSid = '+pEid+','+ pSid);
                lx.file.refreshParent(pEid, pSid, pPublic);
				apex.region( "uiMedia-Chat" ).refresh();
                /*if (window.parent.$('.lxpComments').length != 0 ) {
                    if ([79,39,5].indexOf(pEid) == -1) window.parent.lx.comment.fetchComments();
                }
                if (pEid == 32 && window.parent.lxpGantt) window.parent.lxpGantt.getTaskAjax(pSid, true);
                if ([79].indexOf(pEid) >= 0) {window.parent.apex.region( "uiMedia-Chat" ).refresh();}*/
            }
        });
    },
    detach: function(pRid, pSid, pEid) {
        apex.server.process("delFileAttachment", {
            x01: pRid
        }, {
            dataType: "text",
            success: function(r) {
                apex.submit("REFRESH");
            }
        });
    },
    refreshParent: function (pEid, pSid, pPublic){
        // Notify the parent view after the native attachment service has refreshed.
        var refreshUnhandled = window.parent.document.dispatchEvent(new window.parent.CustomEvent('lp:record-changed', {
            cancelable: true,
            detail: {recordId: pSid, entityId: pEid}
        }));
        /* created on 21.10.2020 by Davor
        * keeping parent refresh actions on one place (they where all over the pg251 and 248)
        */
        // Task gantt row refresh
        if (pEid == 32 && refreshUnhandled && window.parent.lxpGantt) 
            window.parent.lxpGantt.getTaskAjax(pSid, true);
        /*if (pPublic) window.parent.apex.region("publicAttachements").refresh();
		// Comment refresh (if opened in parent)
        else*/ if (typeof window.parent.lx.comment.options.htmlID !== "undefined" &&
                    window.parent.lx.comment.options.etyId == pEid &&
                    window.parent.lx.comment.options.recId == pSid) {//$('.lxpComments').length != 0
            // Refresh comments
            window.parent.lx.comment.fetchComments();
        // Martin, 11.02.2025., aading else if for uploads in feed comments
        } else if (window.parent.$v("pFlowStepId") == 1) {
			window.parent.lx.comment.fetchComments('feedComm-' + pEid + '-' + pSid);
		}
        if ([79].indexOf(pEid) >= 0) {window.parent.lx.msg.chatOpen(pSid);/*window.parent.apex.region( "uiMedia-Chat" ).refresh();*/}
        if ([74].indexOf(pEid) >= 0 ) {window.parent.apex.region( "certIR" ).refresh();  }
    },
    enableEdit: function(pName) {
        $('#uiDocName[name="' + pName + '"]').editable('enable').css({
            'background-color': '#fff',
            'padding': '5px'
        });
        setTimeout(() => {
            $('#uiDocName[name="' + pName + '"]').editable('show');
        }, 100);
    },
    name: function(pId) {
        var fullPath = document.getElementById(pId).value;
        if (fullPath) {
            var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
            var filename = fullPath.substring(startIndex);
            if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
                filename = filename.substring(1);
            }
            return filename;
        }
    },	
    check: function(pList) {
		apex.server.process("CHECKBOX_SET", {
			x01: pList
		}, {
				dataType: 'text',
				success: function (d) {
					//$x('checkListDisp').innerHTML = d; do nothing for now 
				}
			});
    },
    checkAll: function(pId) {
		var vList = '';
		$.box = $('input[type=checkbox][name=file_cbx]');
		$.box.attr('checked', true);
 
		$.box.each(function () {
			vList = vList + ':' + $(this).val()
		});
		lx.file.check(vList);
    },
    checkAllDoc: function() {		
		var vList = '';
		$.box = $('input[type=checkbox][name=file_cbx]');
		$.box.attr('checked', true);
		$.box.each(function () {
			vList = vList + ':' + $(this).val()
		});
		lx.file.check(vList);
    },
	checkChange: function (pThis) {
		apex.server.process("CHECKBOX_CHANGE", {
			x01: pThis.value, //Value that was checked
			x02: pThis.checked ? 'Y' : 'N' // Checked Flag
		}, {
				dataType: 'text',
				success: function (d) {
					$x('checkListDisp').innerHTML = d;
				}
			});
	}, 
    moveconsole: function(pId, pChecked, pEty, pPath, pEdit, pPage, pSearch, pSort) {
         vProcess = 'FileManagementMoveConsole';
         apex.server.process(vProcess, {
             x01: pId,
             x02: pChecked,
             x03: pEty,
             x04: pPath,
             x05: pEdit,
             x06: pPage,
             x07: pSearch,
             x08: pSort
         }, {
             dataType: "html",
             success: function(r) {
                 if (r) {
                     $("#uiMgmtConsole").html(r);
                 }
             }
         });
     },
	 move: function (pList, pId) {
   if (pList) { apex.server.process("FileManagementMove", {
            x01: pList,
            x02: pId
        }, {
            dataType: "text",
            success: function(r) {
                parent.location.reload();
            }
        });}
   else {alert('Please select a file or folder to move');}

    }
};

/*Folder related functions*/
lx.folder = lx.folder || {};

lx.folder = {
    console: function (pRecId, pEtyId, pEdit) {
		lx.load.add();
		apex.server.process("folderUploadConsole", {
			x01: pEtyId,
			x02: pRecId,
			x03: pEdit
			}, {
				dataType: "html",
				success: function (r) {
					lx.load.remove();
					lx.dialog.open({ id: "attachments", html: r, title: "Attached Files", maxWidth: "639px" });
				}
			}
		);
	},
	copyURL: function (pURL) {
		/*apex.item("P229_FILE_URL").setValue(pURL);
		$("#P229_FILE_URL").show().select();
		$(".ui-url-close ").show();*/
		lx.copyToClipboard(pURL);
	},
    enableEdit: function(pName) {
        $('#uiFolderName[name="' + pName + '"]').editable('enable').css({ 'background-color': '#EDEDED', 'padding': '5px' });
        setTimeout(() => {
            $('#uiFolderName[name="' + pName + '"]').editable('show');
        }, 100);
    }
};

var FileMgmtConsole = lx.file.console;
var filesReorder = lx.file.reorder;
var dropFiles = lx.file.drop;
var fileNotes = lx.file.notes;
var setDocAttach = lx.file.attach;
var delDocAttach = lx.file.detach;
var enableFileEdit = lx.file.enableEdit;
var showFolderConsole = lx.folder.console;
var fldrCopyURL = lx.folder.copyURL;
var enableEdit = lx.folder.enableEdit;
var enablFileeEdit = lx.file.enableEdit;
var spCheckSet = lx.file.check;
var spCheckSelectAll = lx.file.checkAll;
var spCheckSelectAll_doc = lx.file.checkAllDoc;
var spCheckChange = lx.file.checkChange;
